
<template>
    <div>
        <template v-if="i.type=='String'">
                         <el-input   v-model="entity[i.field]"
                                       ref="input" :disabled="!!i.IsNotEdit"
                                       @input="function(v){
                                                if(i.OnInput){
                                                    i.OnInput(v)
                                                }
                                        }"
                                        @blur="function(v){
                                                if(i.OnBlur){
                                                    i.OnBlur(v)
                                                }
                                        }"
                                       :placeholder="i.placeholder" @change="function(v){
                                                if(i.OnChange){
                                                    i.OnChange(v)
                                                }
                                        }">

                                        <i v-if="i.SuffixText" slot="suffix" >{{i.SuffixText}}</i>
                                        <i v-if="i.PrefixText" slot="prefix" {{i.PrefixText}}</i>
                                        <i v-if="i.PrependText" slot="prepend" >{{i.PrependText}}</i>
                                        <i v-if="i.AppendText" slot="append" >{{i.AppendText}}</i>

                           </el-input>


                                <div class="bs-example bs-example-bg-classes"
                                     style="color:red"
                                     v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='Autocomplete'">

    <el-autocomplete class="inline-input" v-model="entity[i.field]" :fetch-suggestions="querySearch"  :placeholder="i.placeholder" @change="function(v){
                                                if(i.OnChange){
                                                    i.OnChange(v)
                                                }
                                        }">

                                        </el-autocomplete>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>



<template v-if="i.type=='Label'">
     {{getDataForPath(entity,i.field)}}
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>

<template v-if="i.type=='BooleanLabel'">
     {{getDataForPath(entity,i.field) | toSelect(i.forSelectStoreName)}}
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>

<template v-if="i.type=='Rate'">
    <!-- {{getDataForPath(entity,i.field)}} -->
    
     <el-rate v-model="entity[i.field]" style="margin-top:10px;" allow-half show-score ></el-rate>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='Password'">
    <el-input v-model="entity[i.field]" type="password" :disabled="!!i.IsNotEdit" :placeholder="i.placeholder" @change="function(v){
                                                if(i.OnChange){
                                                    i.OnChange(v)
                                                }
                                        }">
        <i v-if="i.SuffixText" slot="suffix">{{i.SuffixText}}</i>
        <i v-if="i.PrefixText" slot="prefix" {{i.PrefixText}}</i>
        <i v-if="i.PrependText" slot="prepend">{{i.PrependText}}</i>
        <i v-if="i.AppendText" slot="append">{{i.AppendText}}</i>
    </el-input>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>



<template v-if="i.type=='Boolean'">
    <el-radio-group v-model="entity[i.field]">
        <el-radio v-for="item in $store.state['IsAndNot']" class="radio" :label="item.Value">{{item.Text}}</el-radio>
    </el-radio-group>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>

<template v-if="i.type=='Select'">
    <el-select :popper-append-to-body="false" v-model="entity[i.field]" :disabled="!!i.IsNotEdit" :multiple="!!i.IsMultiple"  :clearable="!i.IsNotClearable" :filterable="!i.IsNotFilterable" :placeholder="i.placeholder" @change="function(v){
                                                if(i.OnChange){
                                                     var SelectItemData = new window.$LQ($store.state[i.forSelectStoreName]).First(function(e){return e.Value == v })
                                                    i.OnChange(v,SelectItemData,entity,i)

                                                }
                                        }">
        <el-option v-if="i.SelectSetting" v-for="item in i.SelectSetting" :value="item.Value" :label="item.Text"></el-option>
        <el-option v-if="!i.SelectSetting" v-for="item in $store.state[i.forSelectStoreName]" :value="item.Value" :label="item.Text"></el-option>
    </el-select>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>

<template v-if="i.type=='DateTime'">
    <el-date-picker v-model="entity[i.field]" type="date" :disabled="!!i.IsNotEdit" placeholder="选择日期" :picker-options="pickerOptions1"    value-format="yyyy-MM-dd" >
    </el-date-picker>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='monthTime'">
    <el-date-picker v-model="entity[i.field]" type="month" :disabled="!!i.IsNotEdit" placeholder="选择年月"     value-format="yyyy-MM" >
    </el-date-picker>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='DateTimePicker'">
    <el-date-picker v-model="entity[i.field]" type="datetime" :disabled="!!i.IsNotEdit" placeholder="选择日期" :picker-options="pickerOptions1"    value-format="yyyy-MM-dd HH:mm:ss" >
    </el-date-picker>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='TimePicker'">
    <el-time-picker v-model="entity[i.field]" :disabled="!!i.IsNotEdit" placeholder="任意时间点" >
    </el-time-picker>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='Radio'">
    <el-radio-group v-model="entity[i.field]">
        <el-radio v-for="item in $store.state[i.forSelectStoreName]" :disabled="!!i.IsNotEdit" class="radio" :label="item.Value">{{item.Text}}</el-radio>
    </el-radio-group>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='Checkbox'">
    <el-checkbox-group v-model="entity[i.field]">
        <el-checkbox v-for="item in $store.state[i.forSelectStoreName]" :disabled="!!i.IsNotEdit" :label="item.Value">{{ item.Text }}</el-checkbox>
    </el-checkbox-group>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='Textarea'">
    <el-input v-model="entity[i.field]" :disabled="!!i.IsNotEdit" ref="input" type="textarea" :autosize="{minRows: i.minRows?i.minRows:2,maxRows: i.maxRows?i.maxRows:5}" :placeholder="i.placeholder">
    </el-input>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='FunZTreeSelect'">
    <el-cascader v-if="$store.state[i.forSelectStoreName]" :placeholder="i.placeholder" :disabled="!!i.IsNotEdit" class="ivu-cascader ivu-cascader-show-clear" style="display: block;" :options="$store.state[i.forSelectStoreName]" v-model="i[i.forValueStoreName]"
        change-on-select>
    </el-cascader>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='CheckboxList'">
    <el-checkbox-group v-model="i[i.forValueStoreName]">
        <el-checkbox :label="o.Value" :disabled="!!i.IsNotEdit" v-for="o in $store.state[i.forSelectStoreName]">
            <span>{{o.Text}}</span>
        </el-checkbox>
    </el-checkbox-group>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
<template v-if="i.type=='UploadImage' ">
    <div class="el-form-group">
        <div class="">
            <div :id="i.field+'_UploadImage' + i.UploadRID"><a>{{i.buttonName}}</a></div>
        </div>
        <img :class="i.class" v-if="entity[i.field]" :src="(Urlpath=='/'?'':Urlpath)+entity[i.field]" />
    </div>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>

<template v-if="i.type=='UploadFile'">
    <div class="el-form-group">
        <div class="" v-if="!i.isNotShowButton">
            <div :id="i.field.replace('.','_').replace('.','_').replace('.','_')+'_UploadFile' + i.UploadRID"><a>{{i.buttonName?i.buttonName:g("$上传")}}</a></div>
        </div>
        <a :class="i.class" target="_blank" v-if="entity[i.field]" :href="(Urlpath=='/'?'':Urlpath)+entity[i.field]">{{g('$点击下载')}}</a>
    </div>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>

<template v-if="i.type=='Editor'">
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">
        {{i.error}}</div>
    <quill-editor class="quill-editor" :options="editorOption" v-model="entity[i.field]">
    </quill-editor>
</template>

<template v-if="i.type=='TagList'">
    <el-tag :key="tag" v-for="tag in entity[i.field]" :closable="!i.hideNew" :disable-transitions="false" @close="function(){
                                         if(i.OnRemove){
                                              i.OnRemove(tag)
                                          }
                                    }">
        {{getDataForPath(tag,i.tagField)}}
    </el-tag>
    <el-popover placement="top" width="600" trigger="hover">
        <popover-item :config="i.popperConfig">
        </popover-item>
        <el-button slot="reference" v-if="!i.hideNew" class="button-new-tag" size="small" @click="function(){
                                         if(i.OnRemove){
                                             i.OnNewClick()
                                          }
                                    }">+ New</el-button>
    </el-popover>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='LabelSetting'">
    <el-button slot="reference" v-if="!i.hideNew" class="button-new-tag" size="small" @click="function(){
                                         $router.push('/LabelSetting')
                                        if(window.rootVue.thisWindow){
                                            window.rootVue.thisWindow.LabelSetting_Key = i.fieldsKey;
                                            window.rootVue.thisWindow.LabelSetting = entity[i.field];
                                            window.rootVue.thisWindow.OnLabelSettingChange = function(LabelSetting){
                                                $set(entity,i.field,LabelSetting)
                                                window.rootVue.thisWindow.LabelSetting = LabelSetting;
                                            }
                                        }

                                    }">
        {{g("$查看&设置")}}</el-button>
    <el-button slot="reference" v-if="!i.hideNew" class="button-new-tag" size="small" @click="function(){
                                    $set(i,'IsShowLabelSettingData',!i.IsShowLabelSettingData)
                                    }">
        {{g("$显示/隐藏数据")}}</el-button>
    <el-input v-if="i.IsShowLabelSettingData" v-model="entity[i.field]" :disabled="!!i.IsNotEdit" ref="input" type="textarea" :autosize="{minRows: i.minRows?i.minRows:2,maxRows: i.maxRows?i.maxRows:5}" :placeholder="i.placeholder">
    </el-input>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>



<template v-if="i.type=='SelectLabel'">
     {{getDataForPath(entity,i.field) | toSelect(i.forSelectStoreName)}}
     <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>



<template v-if="i.type=='AddString'">
    <span>{{i.AddString(entity) }}</span>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='AddStringAndButton'">
    <span>{{i.AddString(entity) }}  <el-button  :type="'primary'" :size='"mini"' :style="{marginRight: '5px'}" @click="function(v){
                                                if(i.OnClick){
                                                    i.OnClick(v)
                                                }
                                        }" >{{gets('$选择')}}</el-button></span>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>



<template v-if="i.type=='AddHtml'">
    <div v-html="i.AddHtml(entity)">
    </div>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>




<template v-if="i.type=='Component'">
    <keep-alive>
        <component v-bind:is="i.Component" :entity="entity" :fieldconfig="field" :field="i"></component>
    </keep-alive>
</template>


<template v-if="i.type=='Button'">
    <el-button :type="i.buttonType" :size='"mini"' :style="{marginRight: '5px'}" @click="function(){
                    if(i.OnClick){
                        i.OnClick(entity,field)
                    }

                }">
        {{i.ButtonName}}</el-button>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='ColorPicker'">
    <el-color-picker v-model="entity[i.field]" :disabled="!!i.IsNotEdit">
    </el-color-picker>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>


<template v-if="i.type=='UE'">
    <UE :defaultMsg="entity[i.field]" :UE="i.UE" :contentChange="function(content){
                                     $set(entity,i.field,content)
                                }">
    </UE>
    <div class="bs-example bs-example-bg-classes" style="color:red" v-bind:class="{ show: i.isCheck }">{{i.error}}</div>
</template>
 



</div>
</template>
<style>
    .el-input__inner {
        height: 35px;
    }
    .el-select {
        width: 100%;
    }
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
        width: 100%;
    }
    .ql-toolbar.ql-snow .ql-formats {
        line-height: initial;
    }
</style>

<script>
    import gets from '@/model/language'
    import {
        $Path,
        $Urlpath
    } from '@/config/config.js'
    export default {
        props: ['entity', 'field'],
        data() {
            return {
                restaurants: [],
                window: window,
                value: [1, 6],
                pickerOptions0: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                editorOption: {
                    height: "100px"
                },
                pickerOptions1: {
                    shortcuts: [{
                        text: gets('$今天'),
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: gets('$昨天'),
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: gets('$一周前'),
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
            }
        },
        created() {
            var c = this.field;
            if (c.isCheck === undefined) {
                c.isCheck = true;
            }
            if (!(c.initField === undefined)) {
                c.initField(this, function(nodes) {}, this.entity, c)
            }
        },
        computed: {
            Urlpath() {
                return $Path;
            },
            i() {
                return this.field
            }
        },
        mounted() {
            var gos = this;
            setTimeout(function() {
                var arr = [];
                var imgArr=[]
                const c = gos.field;
                if (c) {
                    if (c.type == 'UploadImage' ) {
                        function cd(data) {
                            return function() {
                                return data;
                            }
                        }
                        arr.push(cd(c))
                    }
                    for (const i of arr) {
                        const g = i();
                        WorkUpLoad({
                            id: "#" + g.field + "_UploadImage"+ g.UploadRID,
                            server: $Urlpath + (g.path ? g.path : "Upload/ImageFileUpload")
                        }, function(f, p) {
                            if (g.initField) {
                                g.initField(gos, function(nodes) {}, gos.entity, g, f, p)
                            } else {
                                gos.$set(gos.entity, g.field, p.Path)
                            }
                        })
                    }
                 
                    arr = [];
                    if (c.type == 'UploadFile') {
                        function cd(data) {
                            return function() {
                                return data;
                            }
                        }
                        arr.push(cd(c))
                    }
                    for (const i of arr) {
                        const g = i();
                        WorkUpLoad({
                            id: "#" + g.field.replace('.', '_').replace('.', '_').replace('.', '_') + "_UploadFile" + g.UploadRID,
                            server: $Urlpath + (g.path ? g.path : "Upload/FileUpload")
                        }, function(f, p) {
                            if (g.initField) {
                                g.initField(gos, function(nodes) {}, gos.entity, g, f, p)
                            } else {
                                gos.$set(gos.entity, g.field, p.Path)
                            }
                        })
                    }
                }
            }, 300);
        },
        methods: {
            g: gets,
            getDataForPath(d, path) {
                var todata = d;
                var ps = path.split('.')
                for (var i of ps) {
                    try {
                        todata = todata[i];
                    } catch (error) {
                        return '';
                    }
                }
                return todata;
            },
            c(value, selectedData) {},
            querySearch(queryString, cb) {
                console.log(this.field.forSelectStoreName)
                var restaurants = this.$store.state[this.field.forSelectStoreName];
                var results = queryString ? restaurants.filter(this.field.Filter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                var p = []
                for(var o of results){
                    p.push(
                        {
                            value:o[this.field.LableField],
                            address:o[this.field.ValueField],
                        })
                }

                cb(p);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=-1);
                };
            },
        },
        watch: {
            entity: function() {
                var c = this.field;
                if (!(c.initField === undefined)) {
                    c.initField(this, function(nodes) {}, this.entity, c)
                }
            }
        }
    }
</script>














// WEBPACK FOOTER //
// form_list_item.vue?6a1cbc5c